module.exports = __webpack_public_path__ + "ad83d6fce3f9526db15b37c5f7674e02.svg";